import { type Config, configSchema } from '@hrms/shared'
import { useQuery } from '@tanstack/react-query'
import { apiGet } from './api.ts'

export const CONFIG_KEY = ['config'] as const

/** Categories, priorities and statuses (ordered, including archived; filter for pickers). */
export function useConfig() {
  return useQuery<Config>({
    queryKey: CONFIG_KEY,
    queryFn: () => apiGet('/config', (d) => configSchema.parse(d)),
    staleTime: 60_000,
  })
}
